import { render, staticRenderFns } from "./AppCoreView.vue?vue&type=template&id=64679398&"
import script from "./AppCoreView.vue?vue&type=script&lang=js&"
export * from "./AppCoreView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports